/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      // Go to prev page
      $( '.quoter-nav .quoter-back' ).click( function() {
        $( '.current-page .gform_previous_button' ).trigger( 'click' );
      } );

      // Go to prev page
      $( '.quoter-nav .quoter-next' ).click( function() {
        if ( $( '.current-page .gform_page_footer input[type="submit"]' ).length ) {
          $( '.current-page .gform_page_footer input[type="submit"]' ).trigger( 'click' );
        } else {
          $( '.current-page .gform_next_button' ).trigger( 'click' );
        }
      } );

      // Set Current Page
      $( '.quoter-skin .gform_page:first-child' ).addClass( 'current-page' ).attr( 'tabindex', '0' );

      // Set progress
      const totalPages = $( '.quoter-page .gform_body .gform_page' ).length;
      const progress = ( 1 / totalPages ) * 100;
      let valueChanged = false;
      $( '.quoter-page .progress-bar .progress' ).css( {
        'width': progress + '%',
      } );

      $( '.start-quoter' ).click( function() {
        $( '.intro-area' ).addClass( 'is-inactive' );
        $( '.quoter-area' ).addClass( 'is-active' );

        if ( $( '.navbar' ).hasClass( 'navbar--quoter-pages' ) ) {
          $( '.quoter-pagination li:first-child .page-item' ).addClass( 'is-active' );
        }
      } );

      const oldName = '[name]';
      let newName = 'employee-to-be';
      $( document ).on( 'change', '.name, .nickname', function() {
        if ( $( '.nickname' ).find( 'input' ).val() ) {
          newName = $( '.nickname' ).find( 'input' ).val();
        } else if ( $( '.name' ).find( 'input' ).val() ) {
          newName = $( '.name' ).find( 'input' ).val();
        } else {
          newName = 'employee-to-be';
        }
        rewriteName( document.body );
      } );

      addClassToName( document.body );
      function addClassToName( node ) {
        $( '.gfield_label, .gsection_title' ).each( function( key, label ) {
          $( label ).html( $( label ).html().replace( oldName, '<span class="cq-user-name">' + oldName + '</span>' ) );
        } );
      }

      rewriteName( document.body );
      function rewriteName( node ) {
        $( '.cq-user-name' ).each( function( key, userName ) {
          $( userName ).text( newName );
        } );
      }

      // Page change stuff
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const progress = ( currentPage / totalPages ) * 100;
        valueChanged = false;
        addClassToName( document.body );
        rewriteName( document.body );

        console.log( currentPage );

        if ( $( '.navbar' ).hasClass( 'navbar--quoter-pages' ) ) {
          $( '.quoter-pagination .page-item' ).removeClass( 'is-active' );
          $( '.quoter-pagination .page-item[data-page="#gform_page_' + formId + '_' + currentPage + '"]' ).addClass( 'is-active' );
        }

        $( '.quoter-nav .quoter-next' ).addClass( 'is-inactive' );
        $( '#gform_page_' + formId +'_' + currentPage + ' .gfield' ).each( function() {
          if ( $( this ).find( 'input[type="text"], input[type="radio"]:checked, input[type="checkbox"]:checked, select, textarea' ).val() ) {
            $( '.quoter-nav .quoter-next' ).removeClass( 'is-inactive' );
          }
        } );

        $( '.quoter-page .progress-bar .progress' ).css( {
          'width': progress + '%',
        } );

        // Update quoter nav
        if ( currentPage > 1 ) {
          $( '.quoter-nav .quoter-back' ).removeClass( 'is-inactive' );
        } else {
          $( '.quoter-nav .quoter-back' ).addClass( 'is-inactive' );
        }

        // Set current page, scroll to top
        $( '.quoter-skin .gform_page' ).removeClass( 'current-page' );
        $( '#gform_page_' + formId +'_' + currentPage ).addClass( 'current-page' ).attr( 'tabindex', '0' );
        $( '.current-page' ).focus();

        if ( !$( '.careers-quoter-skin--design-presentation' ).length ) {
          $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );
        }

        if ( currentPage == $( '.quoter-skin .gform_page' ).length ) {
          $( '.quoter-nav .quoter-next' ).addClass( 'is-finishing' );
        } else {
          $( '.quoter-nav .quoter-next' ).removeClass( 'is-finishing' );
        }

        addLinesToSliders( $( '#gform_page_' + formId +'_' + currentPage )[0] );
      } );

      $( document ).on( 'change', '.current-page input, .current-page select', function() {
        if ( !valueChanged ) {
          $( '.quoter-nav .quoter-next' ).removeClass( 'is-inactive' );
          valueChanged = true;
        }
      } );

      // Hide quoter nav on submit
      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        if ( formId == $( '.careers-quoter-page' ).attr( 'data-form' ) ) {
          $( '.careers-quoter-page .quoter-nav' ).hide();
          $( '.gform_confirmation_message' ).attr( 'tabindex', '0' ).focus();
        }
      } );

      $( document ).on( 'change', '.current-page input[type="radio"]', function() {
        if ( $( '.current-page' ).find( '.section-start .gfield' ).length == 1 ) {
          $( '.current-page .gform_next_button' ).trigger( 'click' );
        }
      } );

      addLinesToSliders( $( '.careers-quoter-skin .gform_page:first-child' )[0] );
      function addLinesToSliders( page ) {
        $( page ).find( '.gfield:not(.custom-slider) .real-slider' ).each( function( key, val ) {
          $( val ).addClass( 'added-lines' );
          const lines = $( val ).find( '.noUi-handle' ).attr( 'aria-valuemax' );
          for ( let i = 1; i < parseInt( lines ); i++ ) {
            $( val ).find( '.noUi-connects' ).append( '<span class="line" style="left:' + ( ( i / ( parseInt( lines ) - 1 ) ) * 100 ) + '%;"></span>' );
          }
        } );
      }

      /* DESIGN PRESENTATION QUOTER */
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        $( '.llgq_gfield_type_radio' ).find( 'input' ).removeClass( 'is-faded-out is-growing' );
        currentPageIsResponse = false;

        if ( $( '#gform_page_' + formId + '_' + currentPage ).hasClass( 'response-page' ) ) {
          currentPageIsResponse = true;
          $( '#gform_page_' + formId + '_' + currentPage ).find( '.previous-response' ).remove();
        }

        const prevAnswerArray = [];

        const prevAnswerPage = $( '#gform_page_' + formId + '_' + ( currentPage - 1 ) )[0];

        $( prevAnswerPage ).find( 'input:checked' ).each( function( key, input ) {
          prevAnswerArray.push( $( input ).closest( '.gchoice' )[0] );
        } );

        let prevAnswer = `<div class="previous-answers__wrapper answers--${prevAnswerArray.length} ${$( prevAnswerPage ).find( 'input:checked' ).closest( '.gfield' ).hasClass( 'tags-list' ) ? 'tags-list' : ''}">`;

        $( prevAnswerArray ).each( function( key, answer ) {
          prevAnswer += `
          <div class="previous-answer__outer">
            <div class="previous-answer ${$( answer ).closest( '.gfield' ).hasClass( 'contain-images' ) ? 'contain-images' : ''}">
              ${$( answer ).find( 'img' ).length > 0 ? $( answer ).find( 'img' )[0].outerHTML : ''}
              ${$( answer ).closest( '.gfield' ).hasClass( 'llgq_gfield_type_checkbox' ) ? '<span>' + $( answer ).find( 'input' ).next().text() + '</span>' : ''}
            </div>
          </div>
        `;
        } );

        prevAnswer += '</div>';

        if ( currentPageIsResponse ) {
          const pageFooter = $( '#gform_page_' + formId + '_' + currentPage ).find( '.gform_page_footer' ).detach();

          $( prevAnswer ).insertAfter( $( '#gform_page_' + formId + '_' + currentPage ).find( '.ginput_container_textarea' ).prev() );
          $( '#gform_page_' + formId + '_' + currentPage ).find( '.ginput_container_textarea' ).append( pageFooter );
        }
      } );

      if ( $( '.careers-quoter-skin--design-presentation' ).length ) {
        $( document ).on( 'change', '.llgq-radio-page input', function() {
          $( this ).closest( '.gchoice' ).addClass( 'is-growing' );
          $( this ).closest( '.llgq_gfield_type_radio' ).find( 'input' ).not( this ).closest( '.gchoice' ).addClass( 'is-faded-out' );
        } );
      }

      if ( $( '.gform_save_link' ).length ) {
        $( '.quoter-nav' ).addClass( 'has-save' );
        $( '.quoter-save' ).text( $( '.gform_page:first-child .gform_save_link' ).text() );
      }

      $( '.quoter-save' ).on( 'click', function() {
        $( '.llgq-current-page .gform_save_link' ).trigger( 'click' );
      } );

      $( '.navbar--quoter-pages button.page-item' ).on( 'click', function() {
        const pageNumber = parseInt( $( this ).attr( 'data-page-num' ) );
        const formId = parseInt( $( this ).attr( 'data-form-id' ) );

        if ( !$( '.intro-area' ).hasClass( 'is-active' ) ) {
          $( '.start-quoter' ).trigger( 'click' );
        }

        goToPage( pageNumber, formId );
      } );

      function goToPage( pageNumber, formId ) {
        const currentPage = $( '.gform_page.llgq-current-page' ).index() + 1;
        $( '.quoter-pagination .page-item' ).removeClass( 'is-active' );
        $( 'input[name="gform_target_page_number_' + formId + '"]' ).val( pageNumber );
        $( 'input[name="gform_source_page_number_' + formId + '"]' ).val( currentPage );
        $( '#gform_' + formId ).trigger( 'submit', [true] );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'careers-quoter', COMPONENT );
} )( app );
